import React from 'react';
import { css } from 'emotion';
import { until, from } from '@guardian/src-foundations/mq';
export const Hide = ({ children, when, breakpoint, el, key, }) => {
    let whenToHide;
    if (when === 'below') {
        whenToHide = css `
			${until[breakpoint]} {
				display: none;
			}
		`;
    }
    else {
        whenToHide = css `
			${from[breakpoint]} {
				display: none;
			}
		`;
    }
    return el === 'li' ? (React.createElement("li", { className: whenToHide, key: key }, children)) : (React.createElement("span", { className: whenToHide }, children));
};
